// extracted by mini-css-extract-plugin
export default {"container":"RemoveUser_container__Gi7Ao","userList":"RemoveUser_userList__kq5uc"};